import { useSelector } from "react-redux";

const useUsers = () => {
    const users = useSelector((state) => state.users);
    return users;
};

export default useUsers;